"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebActionDestination = exports.WebActionSource = exports.WebActionName = exports.BlizzardEvent = exports.PageType = void 0;
// FIXME: PageType is repeated code from content-platform/www
// Generated from https://github.sc-corp.net/Snapchat/content-platform/blob/main/pb-www/src/main/proto/snapchat/web/stories/common.proto#L6-L6
// Remove this enum when we move away from proto-based APIs or when we have better way to share proto generated types between packages
var PageType;
(function (PageType) {
    PageType[PageType["UNSET"] = 0] = "UNSET";
    PageType[PageType["NOT_FOUND"] = 1] = "NOT_FOUND";
    PageType[PageType["NOT_AVAILABLE"] = 2] = "NOT_AVAILABLE";
    PageType[PageType["PREMIUM_PROFILE"] = 3] = "PREMIUM_PROFILE";
    PageType[PageType["PREMIUM_STORY"] = 4] = "PREMIUM_STORY";
    PageType[PageType["PREMIUM_PREVIEW"] = 5] = "PREMIUM_PREVIEW";
    PageType[PageType["LENS_PROFILE"] = 6] = "LENS_PROFILE";
    PageType[PageType["LENS_PREVIEW"] = 7] = "LENS_PREVIEW";
    PageType[PageType["ADD_USER"] = 8] = "ADD_USER";
    /** @deprecated in favour of PRIVATE_USER_PROFILE and PUBLIC_USER_PROFILE */
    PageType[PageType["USER_PROFILE"] = 9] = "USER_PROFILE";
    PageType[PageType["OUR_STORY_SNAP"] = 10] = "OUR_STORY_SNAP";
    PageType[PageType["SPOTLIGHT"] = 11] = "SPOTLIGHT";
    PageType[PageType["LENS_HOME_PAGE"] = 12] = "LENS_HOME_PAGE";
    PageType[PageType["DISCOVER_HOME_PAGE"] = 13] = "DISCOVER_HOME_PAGE";
    PageType[PageType["MEDIA_SHARE"] = 14] = "MEDIA_SHARE";
    PageType[PageType["MAP"] = 15] = "MAP";
    PageType[PageType["CHAT"] = 16] = "CHAT";
    PageType[PageType["PRIVATE_USER_PROFILE"] = 17] = "PRIVATE_USER_PROFILE";
    PageType[PageType["PUBLIC_USER_PROFILE"] = 18] = "PUBLIC_USER_PROFILE";
    PageType[PageType["SEARCH"] = 19] = "SEARCH";
    /** @deprecated use SNAPCHAT_HOME_PAGE */
    PageType[PageType["SNAPCHAT_DOT_COM"] = 20] = "SNAPCHAT_DOT_COM";
    PageType[PageType["SIGN_IN"] = 21] = "SIGN_IN";
    PageType[PageType["SIGN_UP"] = 22] = "SIGN_UP";
    PageType[PageType["PASSWORD_RESET"] = 23] = "PASSWORD_RESET";
    PageType[PageType["DOWNLOAD_MY_DATA"] = 24] = "DOWNLOAD_MY_DATA";
    PageType[PageType["UNLOCK_ACCOUNT"] = 25] = "UNLOCK_ACCOUNT";
    PageType[PageType["WEB_ACCOUNTS"] = 26] = "WEB_ACCOUNTS";
    PageType[PageType["SNAPCHAT_HOME_PAGE"] = 27] = "SNAPCHAT_HOME_PAGE";
    PageType[PageType["DOWNLOAD_PAGE"] = 28] = "DOWNLOAD_PAGE";
    // Login v2 page ids
    PageType[PageType["SIGNIN_ACCOUNT_IDENTIFIER"] = 29] = "SIGNIN_ACCOUNT_IDENTIFIER";
    PageType[PageType["SIGNIN_PASSWORD_CHALLENGE"] = 30] = "SIGNIN_PASSWORD_CHALLENGE";
    PageType[PageType["SIGNIN_OTP_CHALLENGE"] = 31] = "SIGNIN_OTP_CHALLENGE";
    PageType[PageType["SIGNIN_TFA_CHALLENGE"] = 32] = "SIGNIN_TFA_CHALLENGE";
    PageType[PageType["SIGNIN_TIV_CHALLENGE"] = 33] = "SIGNIN_TIV_CHALLENGE";
    PageType[PageType["VOTE"] = 34] = "VOTE";
    PageType[PageType["SNAPCHAT_PLUS_SUBSCRIPTION_SIGNUP"] = 35] = "SNAPCHAT_PLUS_SUBSCRIPTION_SIGNUP";
    PageType[PageType["BETA"] = 36] = "BETA";
    PageType[PageType["SNAPCHAT_PLUS_LANDING_PAGE"] = 37] = "SNAPCHAT_PLUS_LANDING_PAGE";
    PageType[PageType["JOIN_COMMUNITY"] = 38] = "JOIN_COMMUNITY";
    PageType[PageType["COOKIE_SETTINGS"] = 39] = "COOKIE_SETTINGS";
    PageType[PageType["TRANSACTION_REVERT"] = 40] = "TRANSACTION_REVERT";
    PageType[PageType["GROUP_INVITE"] = 41] = "GROUP_INVITE";
    PageType[PageType["TIV_LANDING"] = 42] = "TIV_LANDING";
    PageType[PageType["TRANSACTION_REVERT_SUCCESS"] = 43] = "TRANSACTION_REVERT_SUCCESS";
    PageType[PageType["EMBED_PAGE"] = 44] = "EMBED_PAGE";
    PageType[PageType["TRANSACTION_REVERT_ERROR"] = 45] = "TRANSACTION_REVERT_ERROR";
    // Billing Page IDs
    PageType[PageType["LIST_PLANS"] = 47] = "LIST_PLANS";
    PageType[PageType["PURCHASE_PLAN"] = 48] = "PURCHASE_PLAN";
    PageType[PageType["MY_SUBSCRIPTION"] = 50] = "MY_SUBSCRIPTION";
    PageType[PageType["GIFT_CARD_REDEMPTION"] = 49] = "GIFT_CARD_REDEMPTION";
    PageType[PageType["SIGNIN_SECURITY_QUESTION_CHALLENGE"] = 51] = "SIGNIN_SECURITY_QUESTION_CHALLENGE";
    PageType[PageType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PageType = exports.PageType || (exports.PageType = {}));
var BlizzardEvent;
(function (BlizzardEvent) {
    BlizzardEvent["WEB_PAGE_VIEW_EVENT"] = "WEB_PAGE_VIEW_EVENT";
    BlizzardEvent["WEB_PAGE_SHARE_EVENT"] = "WEB_PAGE_SHARE_EVENT";
    BlizzardEvent["STORY_SNAP_VIEW_WEB"] = "STORY_SNAP_VIEW_WEB";
    BlizzardEvent["STORY_STORY_VIEW_WEB"] = "STORY_STORY_VIEW_WEB";
    BlizzardEvent["WEB_SESSION"] = "WEB_SESSION_EVENT";
    BlizzardEvent["WEB_ACTION"] = "WEB_ACTION";
})(BlizzardEvent = exports.BlizzardEvent || (exports.BlizzardEvent = {}));
var WebActionName;
(function (WebActionName) {
    WebActionName["OpenInSnapchatCta"] = "open_in_snapchat_cta";
    WebActionName["FindMoreLensesClick"] = "find_more_lenses";
    WebActionName["OpenWebChatCta"] = "open_web_chat_cta";
    WebActionName["OpenWebChatHeader"] = "open_web_chat_header";
    WebActionName["NavigationClick"] = "navigation_click";
    WebActionName["TryOnLiveLenses"] = "try_on_live_lenses";
    WebActionName["CamAccessGranted"] = "camera_access_granted";
    WebActionName["CamAccessDenied"] = "camera_access_denied";
    WebActionName["RequestCamAccessFailed"] = "request_camera_access_failed";
    WebActionName["SearchClick"] = "search_click";
    WebActionName["ExploreMoreLensesClick"] = "explore_more_lenses_click";
    WebActionName["SearchResultOpen"] = "search_result_open";
    WebActionName["AdvertisersCTA"] = "advertisers_cta";
    WebActionName["LensTagsCTA"] = "lens_tags_cta";
    WebActionName["ScanQrCode"] = "scan_qr_code";
    WebActionName["ShareWebChatClick"] = "share_web_chat_click";
    // Avoid using specific action name for buttons, use a general one
    // and set ActionSource to indicate where the event is coming from.
    WebActionName["ButtonClick"] = "button_click";
    WebActionName["SwipeLeft"] = "swipe_left";
    WebActionName["SwipeRight"] = "swipe_right";
    WebActionName["SwipeUp"] = "swipe_up";
    WebActionName["SwipeDown"] = "swipe_down";
})(WebActionName = exports.WebActionName || (exports.WebActionName = {}));
var WebActionSource;
(function (WebActionSource) {
    WebActionSource["DownloadPageCard"] = "download_page_card";
    WebActionSource["OpenAppStore"] = "open_app_store";
    WebActionSource["ViewMoreSearchResult"] = "view_more_search_result";
    WebActionSource["HomePage"] = "homepage";
    WebActionSource["DownloadQRCode"] = "download_qr_code";
    WebActionSource["TryNowLink"] = "try_now_link";
    WebActionSource["CTAFooter"] = "cta_footer";
    WebActionSource["PopupCTAModal"] = "popup_cta_modal";
    WebActionSource["MobileNav"] = "mobile_nav";
    WebActionSource["DesktopNav"] = "desktop_nav";
    WebActionSource["MobileNavIcon"] = "mobile_nav_icon";
    WebActionSource["DesktopNavIcon"] = "nav_icon";
    WebActionSource["UpsellToast"] = "upsell_toast";
    WebActionSource["LiveLens"] = "live_lens";
    WebActionSource["NativeDownloadCTA"] = "native_download_cta";
    WebActionSource["MobileLensPreview"] = "mobile_lens_preview";
    WebActionSource["AccountsWelcomePage"] = "web_accounts_welcome_page";
    WebActionSource["DownloadPageHeaderCta"] = "download_page_header_cta";
    WebActionSource["DownloadMyDataLink"] = "download_my_data_link";
    WebActionSource["PlusSignupSubscription"] = "plus_signup_subscribe";
    WebActionSource["PlusSignupSubscriptionComplete"] = "plus_signup_subscription_complete";
    WebActionSource["JoinCommunityOnSnapchat"] = "join_community_on_snapchat";
    WebActionSource["JoinDifferentCommunityOnSnapchat"] = "join_different_community_on_snapchat";
    WebActionSource["GroupInviteOnWeb"] = "group_invite_on_web";
    WebActionSource["SignUp_SignUpAndAccept"] = "sign_up_sign_up_and_accept";
    WebActionSource["SignUp_ArkoseCompleted"] = "sign_up_arkose_completed";
    WebActionSource["SignUp_SubmitOTP"] = "sign_up_submit_otp";
    WebActionSource["SignUp_ResendEmail"] = "sign_up_resend_email";
    WebActionSource["SignUp_SubmitContactInfo"] = "sign_up_submit_contact_info";
    WebActionSource["Embed_OpenInSnapchat"] = "embed_open_in_snapchat";
    WebActionSource["Embed_TryLiveLens"] = "embed_try_live_lens";
    WebActionSource["Embed_CopyCodeClick"] = "embed_copy_code_click";
    WebActionSource["BlockingCTA"] = "blocking_cta";
    WebActionSource["BlockingCTASignUpButton"] = "blocking_cta_sign_up_button";
    WebActionSource["OpenParentMicrositeCta"] = "open_parent_microsite_cta";
    WebActionSource["HomepageLensCarousel"] = "homepage_lens_carousel";
})(WebActionSource = exports.WebActionSource || (exports.WebActionSource = {}));
var WebActionDestination;
(function (WebActionDestination) {
    WebActionDestination["IOSAppStore"] = "ios_app_store";
    WebActionDestination["AndroidGooglePlayStore"] = "android_google_play_store";
})(WebActionDestination = exports.WebActionDestination || (exports.WebActionDestination = {}));
//# sourceMappingURL=types.js.map